import { escapeReferenceToken } from '@criteria/json-pointer'
import { visitOperations } from '@criteria-labs/docs-kit'
import { Change, OpenAPI } from './Change'
import { DeleteOperation, RemoveOperationTag } from './operation'
import { InsertTag, RemoveTag } from './tag'

export class AddResource extends Change {
  constructor(readonly descriptor: { name: string; description?: string }) {
    super()
  }

  apply(document: OpenAPI): void {
    const changes: Change[] = []

    const index = document.tags?.length ?? 0
    changes.push(new InsertTag(index, { name: this.descriptor.name, description: this.descriptor.description }))

    // TODO: default operations

    changes.forEach((change) => change.apply(document))
  }
}

export class DeleteResource extends Change {
  constructor(readonly name: string, readonly deleteOperations: boolean) {
    super()
  }

  apply(document: OpenAPI): void {
    const changes: Change[] = []

    if (this.deleteOperations) {
      visitOperations(document, (path, pathItem, method, operation) => {
        changes.push(new DeleteOperation(`#/paths/${escapeReferenceToken(path)}/${method}`))
      })
    } else {
      visitOperations(document, (path, pathItem, method, operation) => {
        changes.push(new RemoveOperationTag(`#/paths/${escapeReferenceToken(path)}/${method}`, this.name))
      })
    }

    const removeChanges: RemoveTag[] = []
    document.tags?.forEach((tag, index) => {
      if (tag.name === this.name) {
        removeChanges.push(new RemoveTag(index, true))
      }
    })
    changes.push(...removeChanges.toReversed())

    changes.forEach((change) => change.apply(document))
  }
}
